import React from "react";
import "./SettingsPage.css";

export default function SettingsPage() {
  return (
    <div className="fd-settings">
      <div className="fd-settings__header">
        <h1 className="fd-settings__title">Settings</h1>
        <p className="fd-settings__subtitle">
          Account and portal preferences.
        </p>
      </div>

      <div className="fd-settings__panel">
        <div className="fd-settings__section">
          <div className="fd-settings__sectionTitle">Account</div>
          <p className="fd-settings__text">
            Sign-in and authentication are managed through the portal.
          </p>
        </div>

        <div className="fd-settings__divider" />

        <div className="fd-settings__section">
          <div className="fd-settings__sectionTitle">Public site</div>
          <p className="fd-settings__text">
            Use the “Public Site” link in the sidebar to access the public
            experience.
          </p>
        </div>
      </div>
    </div>
  );
}
